import axios from 'axios';
import store from '../store';
import * as types from '../actions/menu-actions';

class MenuApi {
	/**
	 * Set item navigation that was clicked
	 */
	static navClick(item) {
		return (dispatch) => {
			dispatch({
				type: types.NAVIGATION_CLICK,
				item
			});
			return Promise.resolve(item);
		}
	}

	/**
	 * Set item navigation that was clicked
	 */
	static toggleMenu(state) {
		store.dispatch({
				type: types.TOGGLE_MENU,
				state
			});
			return Promise.resolve(state);		
	}
}

export default MenuApi;






// WEBPACK FOOTER //
// ./src/api/menu-api.js